// #1595 — the Class Placings screen's view picker (score-common's
// PLACING_VIEWS, #945/#953) remembers the operator's last manual pick in
// localStorage, so a revisit opens on the view they were last working in
// instead of re-resolving from scratch every time.
//
// Same pattern as this app's rideViewMode.js (#2012) and scribe-fe's
// sheetFieldOrder.js (#671): a namespaced key, try/catch'd get/set so a
// browser with storage disabled (private mode) degrades to "no preference"
// instead of throwing. Per-device display preference, not part of the
// user/account record — it deliberately does not follow an admin across
// devices, and it deliberately ranks BELOW an explicit show-level
// Show.defaultPlacingView (#2000): the show default is a configured
// decision about that show, this is only the fallback the system default
// used to be. See ClassPlacings.jsx's resolvePlacingView for the full
// resolution order.

import { PLACING_VIEWS } from "score-common";

const STORAGE_KEY = "scoreadmin-fe.placingView";

/**
 * @returns {string|null} the operator's last stored pick when it is a value
 * PLACING_VIEWS still recognizes; null when unset, unreadable, or a
 * garbage/stale value (e.g. written by a build with a since-retired view) —
 * the caller falls through to its own default rather than handing an
 * unrecognized value to buildPlacingGroups.
 */
export function getStoredPlacingView() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return Object.values(PLACING_VIEWS).includes(raw) ? raw : null;
  } catch {
    return null;
  }
}

/** @param {string} view - a PLACING_VIEWS value; anything else is ignored. */
export function storePlacingView(view) {
  if (!Object.values(PLACING_VIEWS).includes(view)) return;
  try {
    localStorage.setItem(STORAGE_KEY, view);
  } catch {
    // Storage unavailable (private browsing) — non-fatal; the pick just
    // won't survive the reload.
  }
}
